import { useSelector } from "../AdminRedux";

export const useSystemTheme = () => useSelector(s => s.system.theme);
export const useSystemBackgroundColor = () => {
  const theme = useSystemTheme();
  return theme === "light" ? "#FAF3DD" : "darkgrey";
};
